<!--
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-09-26 19:42:39
 * @LastEditors: luoyang
 * @LastEditTime: 2021-12-30 13:46:24
-->
<template>
  <!-- 关于我们——新闻详情 -->
  <!-- pc端 -->
  <div v-if="isPCFlag" class="news-detail">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分-新闻列表 -->
    <div class="part_news_list containers">
      <!-- <div v-html="webDetail">
      </div> -->
      <div class="news-title">
        {{title}}
      </div>
      <div>
        <div class="update-time">发布时间：{{updateTime}}</div>
      </div>

      <WangEditor class="newsContainer" @change="changeEditor"  v-model="webDetail"></WangEditor>
      <!-- <div class="update-time">{{updateTime}}</div> -->
    </div>
    <!-- 第五部分尾部公用组件 -->
    <bottomFooter></bottomFooter>

  </div>
  <!-- 移动端 -->
  <div v-else class="news-detail-mobile">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>
    <!-- 第二部分-新闻列表 -->
    <div class="part_news_list_mobile mobile-container">
      <!-- <div v-html="webDetail">
      </div> -->
      <div class="news-title">
        {{title}}
      </div>
      <div>
        <div class="update-time">发布时间：{{updateTime}}</div>
      </div>

      <WangEditor class="newsContainer-mobile" @change="changeEditor" @focus="focusEditor" v-model="webDetail"></WangEditor>
      <!-- <div class="update-time">{{updateTime}}</div> -->
    </div>
    <!-- 尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>
</template>

<script>
import WangEditor from "./components/wangEditor";
import topBigPic from "@/components/global/topBigPic.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import bottomFooter from "@/components/global/bottomFooter.vue";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import API from "@/api/homeConfigManage.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "comNewsDetails",
  data() {
    return {
      isPCFlag: true,
      //顶部导航数据
      topBgImg: require("../../assets/imgs/about/newstop_bg.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mbNews/newstop_bg.jpg"),
      bigTitle: {
        znTitle: "公司新闻",
        enTitle: "NEWS FOCUS",
      },

      menuLi: {
        sortOne: {
          title: "关于我们",
          children: [
            {
              name: "产品中心",
              active: false,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: false,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: true,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: this.$route.query.type === "edit" ? "新闻聚焦" : "文化活动",
          children: [
            {
              name: "新闻聚焦",
              //通过路由跳转时携带的type参数，判断新闻类型，在详情页面展示对应的状态
              active: this.$route.query.type === "edit" ? true : false,
              url: "/companyNews",
            },
            {
              name: "文化活动",
              active: this.$route.query.type === "editDynamic" ? true : false,
              url: "/companyDynamic",
            },
          ],
        },
      },

      webDetail: "",
      title: "",
      updateTime: "",
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.getWebDetail();
  },
  methods: {
    // 获取详情
    getWebDetail() {
      // 调用接口
      let queryList = {
        id: this.$route.query.id,
      };
      API.webDetail(queryList)
        .then((res) => {
          this.webDetail = res.content.content;
          this.title = res.content.title;
          this.updateTime = this.toDate(res.content.updateTime.slice(0, 10));
        })
        .catch(() => {});
    },
    toDate(date) {
      let y = date.slice(0, 4);
      let m = date.slice(5, 7);
      let d = date.slice(8);
      return `${y}年${m}月${d}日`;
    },
    //接收子组件的传参
    changeEditor(val) {
      document.activeElement.blur();
      this.webDetail = val;
    },

    focusEditor(){
      document.activeElement.blur();
    }
  },
  components: {
    topBigPic,
    mobileTopBigPic,
    bottomFooter,
    mobileBottomFooter,
    WangEditor,
  },
};
</script>

<style lang="scss">
.news-detail {
  .news-title {
    text-align: center;
    color: #101010;
    font-size: 40px;
    font-weight: bold;
    line-height: 1em;
    margin-bottom: 66px;
  }

  .update-time {
    margin-top: 50px;
    text-align: center;
    color: #999;
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #edefee;
    margin-bottom: 50px;
  }
}

.newsContainer p {
  line-height: 1.8;
}
.newsContainer p img {
  max-width: 980px !important;
  margin: 50px 0;
  margin-left: calc(50% - 490px);
}
/* 移动端 */
.news-detail-mobile {
  .part_news_list_mobile {
    padding: 356px 0 224px;
    .news-title {
      text-align: center;
      color: #101010;
      font-size: 142px;
      font-weight: bold;
      line-height: 213px;
      margin-bottom: 236px;
    }

    .update-time {
      text-align: center;
      color: #999;
      font-size: 57px;
      padding-bottom: 71px;
      border-bottom: 4px solid #edefee;
      margin-bottom: 204px;
    }
  }
  .newsContainer-mobile {
    .w-e-content-preview {
      padding: 0px !important;
    }
    p {
      img {
        max-width: 1778px !important;
        margin: 222px 0;
      }
    }
  }
}
</style>